import { createSelector } from 'reselect'
import { selectCurrentCustomer } from 'selectors/tickets'
import { selectIntegrationSettingsByProvider } from 'ducks/integrations'
import { emptyObj, getValueByPath } from 'util/objects'
import { any } from 'util/arrays'

export const selectIntegrationHubspotData = state =>
  state.integrations.thirdPartyData.hubspot

export const selectIntegrationHubspotContactsData = state =>
  state.integrations.thirdPartyData.hubspot.contacts

export const selectContactsById = createSelector(
  selectIntegrationHubspotContactsData,
  data => data.byId || emptyObj
)

export const selectContactProperties = createSelector(
  selectIntegrationHubspotContactsData,
  data => data.propertiesByName
)

export const selectDealProperties = createSelector(
  selectIntegrationHubspotContactsData,
  data => data.dealPropertiesByName
)

export const selectCompanyProperties = createSelector(
  selectIntegrationHubspotContactsData,
  data => data.companyPropertiesByName
)

export const selectDealStages = createSelector(
  selectIntegrationHubspotContactsData,
  data => data.dealStages
)

export const selectNewContactInitialValues = createSelector(
  selectCurrentCustomer,
  customer => ({
    email: customer.email,
    firstname: customer.first_name,
    lastname: customer.last_name,
    phone: customer.phone_number,
    website: customer.website_url,
    company: customer.company_name,
  })
)

export const selectCreateContactError = createSelector(
  selectIntegrationHubspotContactsData,
  data => data.createContactError || emptyObj
)

export const selectContactByCustomerId = (state, id) => {
  return selectContactsById(state)[id]
}

export const selectContactStateByCustomerId = (state, id) => {
  const found = selectContactByCustomerId(state, id)
  if (found && found.state === 'failed' && found.error.code === 404)
    return 'missing'
  return found ? found.state : 'unknown'
}

export const selectContactListsById = createSelector(
  selectIntegrationHubspotContactsData,
  data => data.listsByCustomerId || emptyObj
)

export const selectContactListsByCustomerId = (state, id) => {
  return selectContactListsById(state)[id]
}

export const selectContactDealsById = createSelector(
  selectIntegrationHubspotContactsData,
  data => data.dealsByCustomerId || emptyObj
)

export const selectContactDealsByCustomerId = (state, id) => {
  return selectContactDealsById(state)[id]
}

export const selectContactCompaniesById = createSelector(
  selectIntegrationHubspotContactsData,
  data => data.companiesByCustomerId || emptyObj
)

export const selectContactCompaniesByCustomerId = (state, id) => {
  return selectContactCompaniesById(state)[id]
}

export const selectContactEngagementsById = createSelector(
  selectIntegrationHubspotContactsData,
  data => data.engagementsByCustomerId || emptyObj
)

export const selectOwnersById = createSelector(
  selectIntegrationHubspotContactsData,
  data => data.ownersById || emptyObj
)

export const selectContactOwnerById = (state, customerId) => {
  const contact = selectContactByCustomerId(state, customerId)
  if (!contact) return null
  const ownerId = getValueByPath('properties.hubspot_owner_id.value', contact)
  if (!ownerId) return null
  const ownersById = selectOwnersById(state)
  return ownersById[ownerId] || emptyObj
}

export const selectContactEngagementsByCustomerId = (state, id) => {
  return selectContactEngagementsById(state)[id]
}

const selectSettings = createSelector(
  selectIntegrationSettingsByProvider,
  data => data.hubspot || emptyObj
)

const selectSettingsKeys = createSelector(selectSettings, settings =>
  Object.keys(settings).filter(key => settings[key])
)

export const selectShouldShowDealSection = createSelector(
  selectSettingsKeys,
  keys => {
    return any(key => key.match('showSidebarField.Deal.'), keys)
  }
)

export const selectShouldShowListSection = createSelector(
  selectSettingsKeys,
  keys => any(key => key.match('showSidebarField.ListMembership'), keys)
)

export const selectShouldShowCompanySection = createSelector(
  selectSettingsKeys,
  keys => any(key => key.match('showSidebarField.Company.'), keys)
)
